import { settleInstallment } from "@api/stores/salesInvoices/installments/settleInstallment/path";
import { settleInstallments } from "@api/stores/salesInvoices/installments/settleInstallments/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/sales-invoices/:salesInvoiceId/installments`;
const pathById = `${pathBase}:installmentId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const installments = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  settleInstallments,
  settleInstallment,
};
